import { Building2 } from 'lucide-react';
import { useId } from 'react';
import { Input } from '@/app/components/ui/input';
import { ENTERPRISE_COPY } from '@/app/constants';
import { cn } from '@/app/utils';

interface EnterpriseIdInputProps {
  enterpriseId: string;
  enterpriseIdError: string;
  onEnterpriseIdChange: (enterpriseId: string) => void;
  label?: string;
  helperText?: string;
  className?: string;
  inputClassName?: string;
  showIcon?: boolean;
  readOnly?: boolean;
}

export const EnterpriseIdInput = ({
  enterpriseId,
  enterpriseIdError,
  onEnterpriseIdChange,
  label,
  helperText,
  className,
  inputClassName,
  showIcon = false,
  readOnly = false,
}: EnterpriseIdInputProps) => {
  const inputId = useId();

  return (
    <div className={cn('w-full', className)}>
      {label && (
        <label htmlFor={inputId} className="mb-2 block text-left font-medium text-sm text-system-white80 leading-5">
          {label}
        </label>
      )}
      <div className="relative">
        {showIcon && (
          <Building2 className="-translate-y-1/2 pointer-events-none absolute top-1/2 left-3.5 size-4 text-system-white48" />
        )}
        <Input
          id={inputId}
          placeholder={ENTERPRISE_COPY.login.enterpriseIdPlaceholder}
          className={cn(
            'h-12 w-full rounded-12 border border-system-white12 bg-system-white08 py-[10px] text-sm text-system-white placeholder:text-system-white64',
            showIcon && 'pl-11',
            readOnly && 'cursor-default text-system-white64',
            inputClassName,
            enterpriseIdError && 'border-system-error',
          )}
          value={enterpriseId}
          onChange={(event) => onEnterpriseIdChange(event.target.value)}
          maxLength={100}
          readOnly={readOnly}
        />
      </div>
      {enterpriseIdError ? (
        <p className="mt-2 text-left text-system-error text-xs">{enterpriseIdError}</p>
      ) : (
        helperText && <p className="mt-2 text-left text-system-white48 text-xs leading-5">{helperText}</p>
      )}
    </div>
  );
};
